import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService, SessionStorageService } from 'angular-web-storage';
import { Observable } from 'rxjs';
import { HttpService } from '../../services/http.service';
import { environment } from 'src/environment/environment';
import { CookieService } from 'ngx-cookie-service';
import { CaseService } from 'src/app/modules/cases/_types/case-service';

@Injectable({
  providedIn: 'root'
})
export class IAService {

  private endpoint:string = 'https://botcobertura.stg.grupocuidacasa.com';
  
  constructor(
    private http: HttpClient
  ) {
    
  }

  caseServiceJobGenerate(service:CaseService):Observable<any>{
    let payload = {
      Id: service.id
    };
    
    return this.http.post(this.endpoint + '/webhooks/expedients', payload, {
      headers: {
        'Content-Type': 'application/json',
        'X-API-KEY': '67311406-3862-472f-a7e8-709f47e9f090'
      }
    });
  }

}
